import { Reservation, Table, CombinedTable } from "@/types/table";

export interface DropValidationResult {
  blockers: string[];     // Hard reasons that should open ForceDropDialog
  warnings: string[];     // Soft signals shown as toast after success
}

/**
 * Soft business validation for a drop (capacity / children / stroller / bookability).
 * Physical conflicts (overlap, locked, inactive, swap) are handled separately by FloorPlanV2.dropEvalMap.
 */
export const validateReservationDrop = (
  reservation: Reservation,
  table: Table,
  _combined?: CombinedTable,
): DropValidationResult => {
  const blockers: string[] = [];
  const warnings: string[] = [];
  const people = reservation.numberOfPeople ?? 0;
  const kids = reservation.numberOfChildren ?? 0;

  if (people > 0 && table.capacity < people) {
    blockers.push(`Capacité insuffisante : ${table.name} = ${table.capacity} place(s) pour ${people} couvert(s).`);
  }
  if (kids > 0 && table.allowsChildren === false) {
    blockers.push(`Table « ${table.name} » non autorisée aux enfants (réservation : ${kids} enfant${kids > 1 ? 's' : ''}).`);
  }
  if (reservation.hasStroller && table.allowsStroller === false) {
    blockers.push(`Table « ${table.name} » non compatible poussette.`);
  }
  if (table.isBookable === false) {
    warnings.push(`Table « ${table.name} » est hors réservation (assignation manuelle uniquement).`);
  }

  return { blockers, warnings };
};
